import { Button } from 'components/base';
import { useEffect, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { TbCalendarEvent } from 'react-icons/tb';

interface BottomTabProps {
  totalPrice: number;
  handleNextState: () => void;
  handlePrevState: () => void;
  orderState: number;
}

const BottomTab = ({
  totalPrice,
  handleNextState,
  handlePrevState,
  orderState,
}: BottomTabProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleVisible = () => {
    setIsOpen(!isOpen);
  };

  const handleButton = () => {
    if (isOpen) {
      handleVisible();
    } else {
      handleNextState();
    }
  };

  const renderButton = () => {
    switch (orderState) {
      case 0:
        return (
          <Button
            theme="PRIMARY"
            className="mt-3 w-full"
            onClick={handleButton}
          >
            <p className="text-base font-semibold text-white">Next</p>
          </Button>
        );
      default:
        return (
          <div className="mt-3 flex justify-between">
            <Button
              theme="OUTLINE"
              className="w-[48%] border-primary-light-blue"
              onClick={handlePrevState}
            >
              <p className="text-base font-semibold text-primary-light-blue">
                BACK
              </p>
            </Button>
            <Button
              theme="PRIMARY"
              className="w-[48%]"
              onClick={handleNextState}
            >
              <p className="text-base font-semibold text-white">Next</p>
            </Button>
          </div>
        );
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  return (
    <div
      className={`fixed bottom-0 w-full overflow-scroll rounded-t-2xl bg-white px-4 pb-6 shadow-bottom-tab transition-height !duration-[2000] ease-in-out lg:hidden ${
        isOpen ? 'h-[65vh] pt-6' : 'h-auto pt-4'
      }`}
    >
      {isOpen ? (
        <div className="flex h-full flex-col justify-between">
          <div>
            <p className="text-base font-semibold text-primary-black">
              Order summary
            </p>

            <div className="my-5 w-full border-b border-[#E4EBF5]" />

            <div className="flex items-center justify-between">
              <div className="max-w-[80%]">
                <p className="text-sm font-semibold text-primary-black">
                  Landing Page
                </p>
                <p className="mt-2 text-xs text-primary-black">Layout #1</p>
              </div>
              <p className="text-sm font-bold text-primary-black">₣2000</p>
            </div>

            <div className="mt-4 flex items-center justify-between">
              <div className="max-w-[80%]">
                <p className="text-sm font-semibold text-primary-black">
                  Additional Page
                </p>
                <p className="mt-2 text-xs text-primary-black">1 Page</p>
              </div>
              <p className="text-sm font-bold text-primary-black">₣2000</p>
            </div>

            <div className="my-5 w-full border-b border-[#E4EBF5]" />

            <div className="mt-4 flex items-center justify-between">
              <p className="text-sm font-semibold text-primary-light-blue">
                Basic Plan discount
              </p>
              <p className="text-sm font-bold text-primary-black">-₣200</p>
            </div>

            <div className="mt-4 flex items-center justify-between">
              <p className="text-sm font-bold text-primary-black">
                Total amount
              </p>
              <p className="text-sm font-bold text-primary-black">₣2000</p>
            </div>

            <div className="mt-6 flex items-center justify-between rounded-md border border-[#CFD8E2] bg-white p-[17.5px]">
              <div className="flex items-center">
                <TbCalendarEvent className="h-5 w-5 text-xl" />
                <p className="ml-2.5 text-xs text-primary-black">
                  Est. delivery
                </p>
              </div>
              <p className="text-xs font-semibold text-primary-black">7 days</p>
            </div>
          </div>

          <Button
            theme="PRIMARY"
            className="mt-3 w-full"
            onClick={handleButton}
          >
            <p className="text-base font-semibold text-white">Close</p>
          </Button>
        </div>
      ) : (
        <div>
          {orderState !== 5 ? (
            <div className="flex items-center justify-between">
              <p className="text-sm text-primary-black">Order summary</p>
              <button className="flex items-center" onClick={handleVisible}>
                <p className="text-lg font-bold text-primary-black">
                  {totalPrice} CHF
                </p>
                <FaChevronDown className="ml-1 h-3 w-3" />
              </button>
            </div>
          ) : (
            <div>
              <div className="flex items-center justify-between rounded-md border border-[#CFD8E2] bg-white p-[17.5px]">
                <div className="flex items-center">
                  <TbCalendarEvent className="h-5 w-5 text-xl" />
                  <p className="ml-2.5 text-xs text-primary-black">
                    Est. delivery
                  </p>
                </div>
                <p className="text-xs font-semibold text-primary-black">
                  7 days
                </p>
              </div>
              <div className="mt-2 flex items-center justify-between">
                <p className="text-sm font-semibold text-primary-light-blue">
                  Basic Plan discount
                </p>
                <p className="text-sm font-bold text-primary-black">-₣200</p>
              </div>

              <div className="mt-3 flex items-center justify-between">
                <p className="text-sm text-primary-black">Total</p>
                <p className="text-lg font-bold text-primary-black">₣2000</p>
              </div>
            </div>
          )}
          {renderButton()}
        </div>
      )}
    </div>
  );
};

export default BottomTab;
